import { z } from 'zod';

export const categorySchema = z.object({
  id: z.string(),
  slug: z.string(),
  nameAr: z.string(),
  nameEn: z.string(),
  icon: z.string().nullable().optional(),
  imageUrl: z.string().nullable().optional(),
  displayOrder: z.number().optional(),
  isActive: z.boolean().optional(),
});
export type Category = z.infer<typeof categorySchema>;
